import { z } from 'zod';

export const UuidSchema = z.string().uuid();

export const EmailSchema = z
  .string()
  .trim()
  .toLowerCase()
  .email({ message: 'Enter a valid email address' })
  .max(254);

export const NonEmptyString = z.string().trim().min(1);

export const PasswordSchema = z
  .string()
  .min(10, 'Password must be at least 10 characters')
  .max(256, 'Password is too long');

/** Generic envelope for API errors returned by the api. */
export const ApiErrorSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    field: z.string().optional(),
  }),
});

export type ApiError = z.infer<typeof ApiErrorSchema>;
